module.exports = __webpack_public_path__ + "3843f1914c90a00845da1427092a1b95.png";